var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { ListItemIcon, MenuItem, ListItemText } from "@mui/material";
import { useState } from "react";
//@ts-ignore
import smallmol_icon from "../../static/images/smallmol_icon.png";
import { smilesIsValid } from "../../FileLoaders/utils/handleLoadSMILES";
import LoadSMilesDialog from "./LoadSMilesDialog";
function FromSMILESMenuItem({ callback }) {
    const testCallback = (value) => {
        if (value.length > 1024) {
            return {
                success: false,
                error: "Exceeded maximum character limit.",
            };
        }
        if (!/^([a-zA-Z0-9=\#\-\:\+\/\\\[\]\(\)\.@%\*]+)?$/.test(value)) {
            return {
                success: false,
                error: "Invalid SMILES string.",
            };
        }
        if (!smilesIsValid(value)) {
            return {
                success: false,
                error: "Invalid SMILES string.",
            };
        }
        return { success: true };
    };
    const handleClick = () => __awaiter(this, void 0, void 0, function* () {
        setOpen(true);
        // const pdbID = await dispatchTextInputDialogEvent({
        //   title: "Load a SMILES string",
        //   text: "SMILES string",
        //   testCallback: testString,
        // });
        // if (pdbID) {
        //   callback(pdbID);
        // }
    });
    const [open, setOpen] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsxs(MenuItem, Object.assign({ onClick: handleClick, dense: true }, { children: [_jsx(ListItemIcon, { children: _jsx("img", { src: smallmol_icon, style: {
                                width: "20px",
                                height: "20px",
                            }, alt: "discord" }) }), _jsx(ListItemText, { children: "Load SMILES" })] }), "sidebar-get-pdb"), _jsx(LoadSMilesDialog, { open: open, onClose: () => setOpen(false), testCallback: testCallback, acceptCallback: callback })] }));
}
export default FromSMILESMenuItem;
